import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as S from "./SeoPage.styles";
import SeoSearchHeader from "../SearchPage/components/ModifySearchHeader/ModifySearchHeaderUI";
import SeoPageHeader from "./containers/SeoPageHeader/SeoPageHeaderUI";
import Filter from "../../containers/Filter/Filter";
import Listing from "./containers/Listing/Listing";
import AlternateListing from "./containers/AlternateListing/AlternateListing";
import SeoContainer from "./containers/SeoContainer/SeoContainer";
import SeoInterLinking from "./containers/SeoInterLinking/SeoInterLinking";
import { pageView } from "../../config/ga";
import {
  lobDataSelector,
  seoFormCouponSelector,
  showLeaveIntentSelector,
  showSEOLeadgenSelector,
} from "./redux/selector";
import LeadGenButton from "./containers/LeadGenButton/LeadGenButton";
import { gcRentalSEOScreen, getLoadedComponent } from "../../config/omni";
import { RentalPageComp } from "../../utils/util-constants";
import { fetchModalInfoAndPackageDetails } from "../../common/redux/thunks";
import { homeHourlyRentalPackageSelector } from "../../common/redux/selector";
import { travellerDetailsCalledSelector } from '../Homepage/redux/selector';
import { getTravellerInformation } from "../Homepage/redux/thunks";
import TripAssistant from "./containers/LeadGenButton/TripAssistant";

export default function RentalPage() {
  const showLOBComponents = useSelector(lobDataSelector);
  const showSEOLeadgen = useSelector(showSEOLeadgenSelector);
  const showLeaveIntent = useSelector(showLeaveIntentSelector);
  const couponData = useSelector(seoFormCouponSelector);
  const hrPackageDetails = useSelector(homeHourlyRentalPackageSelector)
  const travellerDetailsCalled = useSelector(travellerDetailsCalledSelector);
  const [isPageViewCalled, setIsPageViewCalled] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      getLoadedComponent(RentalPageComp)
      dispatch(getTravellerInformation())
      

      if (!Object.keys(hrPackageDetails)?.length) {
        dispatch(fetchModalInfoAndPackageDetails())
      }
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    if (travellerDetailsCalled && !isPageViewCalled) {
      setIsPageViewCalled(true)
      dispatch(pageView(gcRentalSEOScreen))
    }
  }, [travellerDetailsCalled, isPageViewCalled])

  return (
    <S.SeoWrapper>
      <SeoSearchHeader isSeo />
      <S.PageHeader>
        <SeoPageHeader />
      </S.PageHeader>
      <S.SeoPageWrapper>
        <S.PageRight isRoute>
          {!showLOBComponents && (
            <React.Fragment>
              <Listing />
              <AlternateListing />
            </React.Fragment>
          )}
          <SeoContainer />
          <SeoInterLinking />
        </S.PageRight>
        <S.PageLeft>{!showLOBComponents && <Filter isSeo />}</S.PageLeft>
      </S.SeoPageWrapper>
      <TripAssistant pageName="Seo" showIcon={showSEOLeadgen} showLeaveIntent={showLeaveIntent} coupon={couponData}/>
    </S.SeoWrapper>
  );
}
